import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalsService } from 'src/app/modules/shared/services/modals/modals.service';
import { PaymentServices } from 'src/app/business-service/payment-management/payment-services.service';
import { ONBOARDING_METHODS, ORGANIZATION_TYPES, RECORD_STATUS_VALUES } from 'src/app/modules/shared/constants/api-constants';
import { AsyncValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, switchMap, map, catchError, first } from 'rxjs/operators';
import { LoginService } from 'src/app/modules/shared/services/login/login.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent implements OnInit {
  signupForm!: FormGroup;
  isSubmittedAndVerified = false;
  // TODO: use LOV here
  organizationType: any[] = [
    { key: ORGANIZATION_TYPES.AGENT, name: ORGANIZATION_TYPES.AGENT },
    { key: ORGANIZATION_TYPES.DMC, name: ORGANIZATION_TYPES.DMC }
  ]

  showSpinner: boolean = false;

  constructor(
    private _modalService: ModalsService,
    private _fb: FormBuilder,
    private _paymentService: PaymentServices,
    private _loginService: LoginService,
    private _route: ActivatedRoute
  ) { }

  ngOnInit() {
    this._loginService.logoutUser(false);

    let source = this._route.snapshot.data['onboardingMethod'] || ONBOARDING_METHODS.TripMeld;

    this.signupForm = this._fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phoneNumber: [null, Validators.required],
      email: [
        '',
        [Validators.required, Validators.email],
        [this.emailExistsValidator()] // <-- add async validator here
      ],
      organizationName: ['', Validators.required],
      organizationType: ['', Validators.required],
      onboardingMethod: [source, Validators.required],
      address: [null],
      companySize: ['', [Validators.required]],
      agree: [false, Validators.requiredTrue]
    });
  }

  onSubmit() {
    if (this.signupForm.invalid) {
      this.signupForm.markAllAsTouched();
      this.signupForm.markAllAsTouched();
      return;
    }

    this.showSpinner = true;
    const payload = this.serializeFormData();

    this._paymentService.signUp(payload).subscribe({
      next: (res: any) => {
        this.isSubmittedAndVerified = true;
        this.showSpinner = false
      },
      error: (err: any) => {
        console.error('Error:', err);
        this.showSpinner = false
      }
    });
  }
  // existing email validation

  emailExistsValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        return of(null);
      }

      const email = control.value.trim().toLowerCase();

      return of(email).pipe(
        debounceTime(300),
        switchMap(email => this._paymentService.getUserEmailExists(email)),
        map((res: any) => {
          return res?.userEmailExists ? { emailTaken: true } : null;
        }),
        catchError((error) => {
          console.error('Email check error:', error);
          return of(null);
        }),
        first()
      );
    };
  }

  serializeFormData() {
    const f = this.signupForm.value;
    const address = f.address || {};
    return {
      organizationDetails: {
        name: f.organizationName,
        organizationType: f.organizationType,
        onboardingMethod: f.onboardingMethod,
        email: f.email,
        country: address.country?.name || '',
        state: address.state || '',
        city: address.city || '',
        zipCode: address.zipCode || '',
        size: f.companySize || '',
      },
      userDetails: {
        userDetail: {
          firstName: f.firstName,
          lastName: f.lastName || '',
          officePhoneNumber: {
            countryCode: f.phoneNumber.countryCode,
            phone: f.phoneNumber.phone || '',
          },
          email: f.email,
        }
      }
    };
  }


  privacyAndPolicy() {
    this._modalService.openPrivacyAndPolicy();
  }
}
